import React, { memo } from 'react';
import styled from 'styled-components';
import { CircleArrow } from '../../../common/icons/circleArrow';

interface ForecastsCardTrayNavItemProps {
    handleClick(): void;
    arrowDirection: number;
    isDisabled: boolean;
}

export const ForecastsCardTrayNavItem = memo(({
    handleClick,
    isDisabled,
    arrowDirection = 0 }: ForecastsCardTrayNavItemProps) => {

    return (
        <ForecastsCardTrayNavItemContainer isDisabled={isDisabled} onClick={handleClick}>
            <CircleArrow width={35} height={35} strokeColor='#ffffff' fillColor='#ffffff' currentRotation={arrowDirection} /> 
        </ForecastsCardTrayNavItemContainer>
    );
});

ForecastsCardTrayNavItem.displayName = 'ForecastsCardTrayNavItem';

interface ForecastsCardTrayNavItemContainerProps {
    isDisabled: boolean;
}

const ForecastsCardTrayNavItemContainer = styled.div<ForecastsCardTrayNavItemContainerProps>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 100%;
    margin: 0 5.3px;
    opacity: 1;
    &:hover {
        cursor: pointer;
    }
    ${({ isDisabled }) => isDisabled && `
        pointer-events: none;
        opacity: 0.4;
    `}
`;